import Languages from 'ha/constants/Languages';

export function hasLanguage({ params: { lang = '' } }) {
  return Object.keys(Languages).includes(lang.toLowerCase());
}
